module.exports = __webpack_public_path__ + "img/alien.61c953a9.png";